/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import desk from "assets/images/Services/Office/desk1.jpg";
import meetingroom from "assets/images/Services/Office/meetingroom1.jpg";
import bathroom from "assets/images/Services/Office/bathroom1.jpg";
import commonArea from "assets/images/Services/Office/commonArea1.jpg";
import reception from "assets/images/Services/Office/reception1.jpg";

const cleaningCategories = [
  {
    image: desk,
    name: "Workstations and Desks",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping down desks and surfaces",
      "Emptying and cleaning trash bins",
      "Disinfecting high-touch areas (keyboards, phones, and desk accessories)",
    ],
  },
  {
    image: meetingroom,
    name: "Meeting Rooms",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping tables and chairs",
      "Disinfecting shared surfaces",
      "Vacuuming or mopping floors",
    ],
  },
  {
    image: bathroom,
    name: "Bathrooms",
    position: { color: "info", label: "" },
    description: [
      "Cleaning and disinfecting toilets, sinks, and counters",
      "Polishing mirrors",
      "Emptying trash bins and replacing liners",
      "Restocking consumables (toilet paper, hand soap, etc.) if provided",
    ],
  },
  {
    image: commonArea,
    name: "Common Areas",
    position: { color: "info", label: "" },
    description: [
      "Cleaning and disinfecting countertops, tables, and chairs in breakrooms",
      "Wiping down appliances (microwave, refrigerator exterior)",
      "Restocking supplies (e.g., paper towels, napkins, or soap if provided)",
      "Vacuuming and mopping floors",
    ],
  },
  {
    image: reception,
    name: "Reception and Entry Areas",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping surfaces",
      "Cleaning glass doors and windows (reachable interior surfaces)",
      "Vacuuming or mopping floors",
    ],
  },
];

function Office_Section4() {
  return (
    <Container>
      <Grid container direction="column" alignItems="center" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our Regular Office Cleaning Services?"
            contents="We understand every workspace is unique, but our standard office cleaning checklist ensures a spotless and professional environment. Here’s what’s typically included in our regular office cleaning services:"
          />
        </Grid>
        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Office_Section4;
